import React, { useEffect, useRef, useState } from 'react';
import { Box } from '@chakra-ui/react';
import PrintPreview from './PrintPreview';
import { useReactToPrint } from 'react-to-print';
import { useDispatch, useSelector } from 'react-redux';
import DataTable from '../../common/dataTable/DataTable';
import { getAllCertForGen } from '../../../api/certificates';
import { FETCH_GSP_APPLICATIONS_FOR_GEN } from '../../../store/actions/actionTypes';
import { LOGS_TABLE_DISPLAY_SIZE, BADGE_STATE_COLORS } from '../../../constants/dataTableConstants';

const GspGeneration = () => {
  const dispatch = useDispatch();
  const gspCertPrintRef = useRef();
  const [printData, setPrintData] = useState();
  const data = useSelector((state) => state.certificate.gspApplicationsGen);

  useEffect(() => {
    document.title = 'BTMA - Certificate Generation';
  }, []);

  const printGspCertificate = useReactToPrint({
    documentTitle: `BTMA-GSP-Certificate-${printData?.millName}-${printData?.certData?.certificateNum}`,
    content: () => gspCertPrintRef.current,
  });

  const columns = [
    { header: 'Certificate No', accessor: 'certificateNum' },
    { header: 'Date', accessor: 'createdAt', isDate: true },
    { header: 'Mill Name', accessor: 'millName' },
    {
      header: 'Status',
      accessor: 'status',
      isBadge: true,
      colorScheme: BADGE_STATE_COLORS,
      hoverInfo: ['remarks'],
    },
    {
      header: 'Action',
      accessor: 'status',
      isButton: true,
      actionScheme: [{ group: 'APPROVED', variant: 'print', action: 'PRINT' }],
    },
  ];

  const handlePagination = async ({ page, pageSize, searchKey, startDate, endDate }) => {
    dispatch({ type: FETCH_GSP_APPLICATIONS_FOR_GEN, payload: null });
    const params = {
      page,
      endDate,
      pageSize,
      searchKey,
      startDate,
      type: 'GSP',
    };
    const res = await getAllCertForGen({ type: 'production', params });
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_GSP_APPLICATIONS_FOR_GEN, payload: res.data });
    }
  };

  const handleSearch = async ({ searchKey, startDate, endDate }) => {
    dispatch({ type: FETCH_GSP_APPLICATIONS_FOR_GEN, payload: null });
    const params = {
      endDate,
      searchKey,
      startDate,
      type: 'GSP',
    };
    const res = await getAllCertForGen({ type: 'production', params });
    if (res.data?.status === 200) {
      dispatch({ type: FETCH_GSP_APPLICATIONS_FOR_GEN, payload: res.data });
    }
  };

  const handlePrint = ({ rowObject }) => {
    const { millName, hoName, msAddress, gspYarnExport, gspFabricExport } = rowObject;
    setPrintData({
      millName,
      millAddress: hoName,
      factoryAddress: msAddress,
      certData: gspYarnExport || gspFabricExport,
      type: gspYarnExport ? 'YARN' : gspFabricExport ? 'FABRIC' : null,
    });
    setTimeout(() => {
      printGspCertificate();
    }, 500);
  };

  return (
    <Box p={4}>
      <DataTable
        topPanel
        keySearch
        dateRange
        isPaginated
        columns={columns}
        search={handleSearch}
        currentPage={data?.page}
        data={data?.certificates}
        caption="GSP Certificates"
        paginate={handlePagination}
        entries={data?.totalEntries}
        currentPageSize={data?.pageSize}
        pageSizes={LOGS_TABLE_DISPLAY_SIZE}
        actions={{
          PRINT: handlePrint,
        }}
      />
      <Box display="none">
        <PrintPreview ref={gspCertPrintRef} data={printData} />
      </Box>
    </Box>
  );
};

export default GspGeneration;
